import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

import { Text } from 'components/library';
import RoundButton from 'components/BackButton/BackButton';
import * as S from './styled';

type Props = { title: string; Badge: string; children: ReactNode };

const ReminderReason = ({ title, children, Badge }: Props) => {
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.Badge>
        <RoundButton size={56} backgroundColor="surface-secondary">
          <Badge />
        </RoundButton>
      </S.Badge>
      <Text mb={20} type="h6">
        {t(title)}
      </Text>
      {children}
    </S.Container>
  );
};

export default ReminderReason;
